// extracted by mini-css-extract-plugin
export default {"list":"todo-list_styles_list__N12bS","message":"todo-list_styles_message__BfB+i"};